/* eslint-disable no-underscore-dangle */
import React from 'react';
import { PwcCKEditors } from '@pwc/pwc-deals-rich-text-editor';
import { Icon } from '@pwc/pwc-deals-ui';
import { UserUtilities } from '@pwc/pwc-deals-web-common';
import { renderToStaticMarkup } from 'react-dom/server';

const { ClassicEditor } = PwcCKEditors;
const { CommentView } = ClassicEditor;

export const createVersionDisplay = (
  commentThreads,
  model,
  currentUser,
  projectId
) => {
  const currentUserIsPractitioner = UserUtilities.isPractitioner(
    currentUser,
    +projectId
  );
  const thread = commentThreads.find((t) => t.id === model.threadId);
  const comment =
    thread && thread.comments.find((c) => c.commentId === model.id);
  return currentUserIsPractitioner && comment && comment.entityVersion > 0
    ? `v${comment.entityVersion} - `
    : '';
};

export const getCommentAuthorClass = (users, model, projectId) => {
  const user = users.find((u) => u.id.toString() === model.author.id);

  if (user) {
    if (!UserUtilities.isPractitioner(user, +projectId)) {
      return 'comment-client-user';
    }

    return 'comment-pwc-user';
  }

  return 'comment-unknown-user';
};

export default (
  commentThreads,
  users,
  isProjectDisabled,
  projectId,
  currentUser
) =>
  class CustomCommentView extends CommentView {
    getTemplate() {
      const versionDisplay = createVersionDisplay(
        commentThreads,
        this._model,
        currentUser,
        projectId
      );
      const templateDefinition = super.getTemplate();

      const commentDivWrapper = templateDefinition.children[0]; // ck-comment ck-annotation
      const commentContentWrapper = commentDivWrapper.children[1]; // ck-comment__main ck-annotation__main

      commentContentWrapper.attributes = {
        ...commentContentWrapper.attributes,
        style: {
          display: 'grid',
          'grid-template-columns': 'repeat(2, 1fr)',
        },
      };

      const commentContent = commentContentWrapper.children[2];
      const commentButtons = commentContentWrapper.children[1];

      const commentButtonsArray = commentButtons.children;
      commentButtons.attributes = {
        ...commentButtons.attributes,
        style: {
          display: 'flex',
          'justify-content': 'flex-end',
          'align-items': 'center',
        },
      };

      const editButton = commentButtonsArray[0];
      const removeButton = commentButtonsArray[1];

      const usernameAndTime = commentContentWrapper.children[0];

      const userNameTag = usernameAndTime.children[0];
      const timeTag = usernameAndTime.children[1];

      const avatarClass = getCommentAuthorClass(users, this._model, projectId);

      commentDivWrapper.attributes = {
        ...commentDivWrapper.attributes,
        class: [...commentDivWrapper.attributes.class, avatarClass],
      };

      const versionTag = {
        tag: 'span',
        children: [`${versionDisplay}`],
        attributes: { class: 'entity-version' },
      };

      timeTag.children.unshift(versionTag);

      timeTag.attributes = {
        ...timeTag.attributes,
        style: {
          margin: '-4px 0px 0px 0px',
          'grid-column': '1/3',
          'grid-row': '2',
        },
      };

      commentContent.attributes = {
        ...commentContent.attributes,
        style: {
          'margin-top': '8px',
          'grid-column': '1/3',
          'grid-row': '3',
        },
      };

      commentContentWrapper.children = [
        userNameTag,
        timeTag,
        commentButtons,
        commentContent,
      ];

      const editIcon = renderToStaticMarkup(<Icon name="pencil" width="12" />);

      const removeIcon = renderToStaticMarkup(
        <Icon name="delete" width="12" />
      );

      editButton.set({
        icon: editIcon,
        isEnabled: !isProjectDisabled,
      });
      removeButton.set({
        icon: removeIcon,
        isEnabled: !isProjectDisabled,
        isVisible:
          currentUser.id.toString() ===
          commentDivWrapper.attributes['data-author-id'],
      });

      return templateDefinition;
    }
  };
